import React from 'react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import Sidebar from 'src/components/Sidebar'
import Footer from 'src/components/Footer'
import Seo from 'src/components/Seo'

const Page = ({ location, pageContext, children }) => (
  <div className="flex flex-col h-full bg-primary">
    <Seo />
    <Sidebar location={location} />
    <div className="flex ml-auto lg:ml-60 h-full">
      <div className="flex flex-col justify-between mx-8 lg:mx-40 2xl:mx-96">
        <main>
          <header className="my-6">
            {pageContext?.title && <h1 className="mb-0">{pageContext.title}</h1>}
            {pageContext?.date && <p className="text-xs text-gray-400">Created on {pageContext.date}</p>}
            {pageContext?.updatedDate && <p className="text-xs text-gray-400">Last updated on {pageContext.updatedDate}</p>}
          </header>

          {children || <MDXRenderer localImages={pageContext.localImages}>{pageContext.body}</MDXRenderer>}
        </main>
        <Footer />
      </div>
    </div>
  </div>
)

export default Page
